import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storege from 'redux-persist/lib/storage';

// reducer import
import customizationReducer from './customizationReducer';
import accountReducer from './accountReducer';
import fetchStateReducer from './fetchStateReducer';
import apiListReducer from './apiListReducer';
import userInfoReducer from './userInfoReducer';

const persistConfig = {
    key: 'root',
    // localStorage에 저장합니다.
    storage: storege,
    whitelist: ['accountReducer', 'userInfoReducer'],
    // blacklist -> 그것만 제외합니다
    keyPrefix: ''
};
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    accountReducer,
    userInfoReducer,
    fetchStateReducer,
    apiListReducer
});

export default persistReducer(persistConfig, reducer);
